import React from 'react';
import './App.css';

import logo from './images/logo20211224.png';
import { Link } from 'react-router-dom';

class Header extends React.Component {
  render() {
    return (
      <nav className="navbar navbar-expand-md navbar-light navbar-border">
        
        <div className="link-container">
          <Link className="nav-link active" to="/work">
            <span className="menu-title" data-i18n="">Work</span>
          </Link>
          <Link className="nav-link active" to="/news">
            <span className="menu-title" data-i18n="">News</span>
          </Link>
          <Link className="nav-link active" to="/cv">
            <span className="menu-title" data-i18n="">CV</span>
          </Link>
          <Link className="nav-link active" to="/contact">
            <span className="menu-title" data-i18n="">Contact</span>
          </Link>
        </div>

        <a className="navbar-brand logo" href="/work">
          <img width="38px" src={logo} alt="logo"/>
        </a>
      </nav>
    );
  }
}

export default Header;
